<template slot="body">
  <div>
    <!-- 授权弹窗start -->
    <!-- pc端-->
    <c-base-dialog
      v-if="isPlatformPc"
      v-model="showConfirmPop"
      :option="confirmPop"
      @cancel="cancelAuthorize"
      @confirm="confirmAuthorize"
      v-transfer-dom
    >
      <template slot="body">
        <div class="base-role-body-content-pc">
          <div class="base-role-pop-body-pc">
            <div class="base-role-confirm-content-pc">
              本活动将获取你的游戏区服信息、角色昵称，以发放游戏权益内容。
            </div>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!-- h5端 -->
    <van-popup
      v-else
      v-model="showConfirmPop"
      round
      position="center"
      :style="showComfirmPopStyle"
    >
      <div class="base-role-pop-content">
        <div class="base-role-pop-title">请确认授权</div>
        <div class="base-role-pop-body">
          <div class="base-role-confirm-content">
            本活动将获取你的游戏区服信息、角色昵称，以发放游戏权益内容
          </div>
        </div>
        <div class="base-role-act">
          <span class="base-role-top-line"></span>
          <div class="base-role-act-cancel" @click="cancelAuthorize">取消</div>
          <div class="base-role-act-confirm" @click="confirmAuthorize">
            确定
          </div>
          <span class="base-role-center-line"></span>
        </div>
      </div>
    </van-popup>
    <!-- 授权弹窗end -->

    <!-- 角色列表弹窗start -->
    <!-- pc端 -->
    <c-base-dialog
      v-if="isPlatformPc"
      v-model="isShowRoleList"
      :option="roleListPop"
      @cancel="closeRoleList"
      @confirm="changeActBind"
      v-transfer-dom
    >
      <template slot="body">
        <div class="base-role-body-content-pc">
          <div class="base-role-body-pc">
            <ul class="base-role-content-pc">
              <li class="base-role-list-li-pc" v-if="isRoleReady === true">
                <div class="base-role-bind-info-pc">
                  <div class="base-role-bind-name-pc">{{ roleName }}</div>
                  <div class="base-role-bind-area-pc">{{ partitionName }}</div>
                </div>
                <div
                  class="base-role-is-bind-role-pc"
                  @click="changeSelect(roleInfo, -1)"
                >
                  <div class="is-bind" v-show="checkIndex === -1">
                    <img
                      src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png"
                      alt=""
                    />
                  </div>
                  <div class="no-bind" v-show="checkIndex !== -1">
                    <img
                      src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png"
                      alt=""
                    />
                  </div>
                </div>
              </li>
              <template v-if="getAllBindRoleTag && allBindRoleList.length>0">
                  <li class="base-role-list-li-pc" v-for=" (bindinfo, index) in allBindRoleList" :key="index"
                      v-show="(bindinfo.role_id !== roleInfo.role_id || bindinfo.partition_id !== roleInfo.partition_id
                      || bindinfo.plat_id !== roleInfo.plat_id) || isRoleReady === false">
                    <div class="base-role-bind-info-pc">
                      <div class="base-role-bind-name-pc">{{bindinfo.role_name | base64decode}}</div>
                      <div class="base-role-bind-area-pc">{{bindinfo.partition_name | base64decode}}</div>
                    </div>
                    <div class="base-role-is-bind-role-pc" @click="changeSelect(bindinfo,index)">
                      <div class="is-bind-pc" v-show="index === checkIndex">
                        <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png" alt="">
                      </div>
                      <div class="no-bind-pc" v-show="index !== checkIndex">
                        <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png" alt="">
                      </div>
                    </div>
                  </li>
                </template>
            </ul>
          </div>
          <div class="base-role-add-other-role-pc" @click="showAddRolePopup">
            <img class="base-role-add-other-role-img-pc" src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/add_icon.png" alt="">
            <span class="base-role-add-other-role-span-pc">选择其他角色</span>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!-- h5端 -->
    <div v-else class="base-role-list-tc" v-show="isShowRoleList">
      <div class="base-role-tc-zz"></div>
      <div class="base-role-list-content">
        <div class="base-role-pop-title">请选择游戏角色</div>
        <div class="base-role-body">
          <div>
            <ul class="base-role-content">
              <li class="base-role-list-li" v-if="isRoleReady === true">
                <div class="base-role-bind-info">
                  <div class="base-role-bind-name">{{ roleName }}</div>
                  <div class="base-role-bind-area">{{ partitionName }}</div>
                </div>
                <div
                  class="base-role-is-bind-role"
                  @click="changeSelect(roleInfo, -1)"
                >
                  <div class="is-bind" v-show="checkIndex === -1">
                    <img
                      src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png"
                      alt=""
                    />
                  </div>
                  <div class="no-bind" v-show="checkIndex !== -1">
                    <img
                      src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png"
                      alt=""
                    />
                  </div>
                </div>
                <span class="base-role-bind-role-line"></span>
              </li>
              <template v-if="getAllBindRoleTag && allBindRoleList.length > 0">
                <li
                  class="base-role-list-li"
                  v-for="(bindinfo, index) in allBindRoleList"
                  :key="index"
                  v-show="
                    bindinfo.role_id !== roleInfo.role_id ||
                    bindinfo.partition_id !== roleInfo.partition_id ||
                    bindinfo.plat_id !== roleInfo.plat_id ||
                    isRoleReady === false
                  "
                >
                  <div class="base-role-bind-info">
                    <div class="base-role-bind-name">
                      {{ bindinfo.role_name | base64decode }}
                    </div>
                    <div class="base-role-bind-area">
                      {{ bindinfo.partition_name | base64decode }}
                    </div>
                  </div>
                  <div
                    class="base-role-is-bind-role"
                    @click="changeSelect(bindinfo, index)"
                  >
                    <div class="is-bind" v-show="index === checkIndex">
                      <img
                        src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/ybd.png"
                        alt=""
                      />
                    </div>
                    <div class="no-bind" v-show="index !== checkIndex">
                      <img
                        src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/nbd.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <span class="base-role-bind-role-line"></span>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="base-role-add-other-role" @click="showAddRolePopup">
          <img
            class="base-role-add-other-role-img"
            src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/add_icon.png"
            alt=""
          />
          <span class="base-role-add-other-role-span">选择其他角色</span>
        </div>
        <div class="base-role-act">
          <span class="base-role-top-line"></span>
          <div class="base-role-act-cancel" @click="closeRoleList">取消</div>
          <div class="base-role-act-confirm" @click="changeActBind">确定</div>
          <span class="base-role-center-line"></span>
        </div>
      </div>
    </div>
    <!-- 角色列表弹窗end -->

    <!-- 添加游戏角色start -->
    <!-- pc端已完成 -->
    <c-base-dialog
      v-if="isPlatformPc"
      v-model="showAddRolePop"
      :option="popOption"
      @cancel="closeAddRolePop"
      @confirm="confirmAddRole"
      class="game-role-select"
      v-transfer-dom
    >
      <template slot="body">
        <div class="base-role-body-content-pc">
          <div class="base-role-pop-body-pc">
            <!-- 平台 -->
            <div class="base-role-add-area-pop-list-pc" v-show="!isClientGame">
              <p class="base-role-pop-p-left-pc">平台</p>
              <div class="base-role-pop-p-right-pc" ref="showAreaPop">
                <div
                  class="base-role-pop-p-right-select-pc"
                  @click="showAreaPopup"
                >
                  <span
                    class="base-role-color-light-pc"
                    v-if="selectedArea === -1"
                    >请选择</span
                  >
                  <span class="base-role-color-light-on-pc" v-else>{{
                    selectedArea
                  }}</span>
                  <img
                    v-if="!showAreaPop"
                    class="base-role-arrowhead-box-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                  <img
                    v-else
                    class="base-role-arrowhead-box-no-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                </div>
                <div
                  class="base-role-pop-p-right-select-list-pc"
                  v-show="showAreaPop"
                >
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-if="areaColumn && areaColumn.length > 0"
                  >
                    <ul>
                      <li
                        :class="[selectedAreaBg === item.text ? 'base-role-select-list-action' : '']"
                        v-for="(item, index) in areaColumn"
                        :key="index"
                        @mouseover="areaOnMouseOver(item)"
                        @click="areaOnConfirm(item)"
                      >
                        {{ item.text }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- 大区 -->
            <div
              class="base-role-add-area-pop-list-pc"
              v-show="area_channel_select === 1"
            >
              <p class="base-role-pop-p-left-pc">大区</p>
              <div class="base-role-pop-p-right-pc" ref="showAreaChannelPop">
                <div
                  class="base-role-pop-p-right-select-pc"
                  @click="showAreaChannelPopup"
                >
                  <span
                    class="base-role-color-light-pc"
                    v-if="selectedAreaChannel === -1"
                    >请选择</span
                  >
                  <span class="base-role-color-light-on-pc" v-else>{{
                    selectedAreaChannel
                  }}</span>
                  <img
                    v-if="!showAreaChannelPop"
                    class="base-role-arrowhead-box-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                  <img
                    v-else
                    class="base-role-arrowhead-box-no-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                </div>
                <div
                  class="base-role-pop-p-right-select-list-pc"
                  v-show="showAreaChannelPop"
                >
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-if="areaChannelColumn && areaChannelColumn.length > 0"
                  >
                    <ul>
                      <li
                        v-for="(item, index) in areaChannelColumn"
                        :class="[selectedAreaChannelBg === base64(item.name) ? 'base-role-select-list-action' : '']"
                        :key="index"
                        @mouseover="areaChannelOnMouseOver(item)"
                        @click="areaChannelOnConfirm(item)"
                      >
                        {{ item.name | base64decode }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- 小区/区服 -->
            <div class="base-role-add-area-pop-list-pc">
              <p class="base-role-pop-p-left-pc">
                {{ area_channel_select === 1 ? "小区" : "区服" }}
              </p>
              <div class="base-role-pop-p-right-pc" ref="showPartitionPop">
                <div
                  class="base-role-pop-p-right-select-pc"
                  @click="showPartitionPopup"
                >
                  <span
                    class="base-role-color-light-pc"
                    v-if="selectedPartitionName === -1"
                    >请选择</span
                  >
                  <span class="base-role-color-light-on-pc" v-else>{{
                    selectedPartitionName
                  }}</span>
                  <img
                    v-if="!showPartitionPop"
                    class="base-role-arrowhead-box-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                  <img
                    v-else
                    class="base-role-arrowhead-box-no-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                </div>
                <div
                  class="base-role-pop-p-right-select-list-pc base-role-pop-p-right-select-list-partition-pc"
                  v-show="showPartitionPop"
                >
                  <div class="base-role-arrowhead-box-search-pc">
                    <img
                      class="base-role-arrowhead-box-pc"
                      src="https://act.xinyue.qq.com/activity/tgclub/14564/9f54b976c057f2b5cfa7fb1f9c28316a.jpg"
                      alt=""
                    />
                    <div class="base-role-select-showPartition-parent-pc">
                      {{ partitionKeyWord }}
                      <input
                        class="base-role-select-showPartition-pc"
                        @input="handleSearchPartitions(partitionKeyWord)"
                        v-model="partitionKeyWord"
                        placeholder="搜索"
                      />
                    </div>
                  </div>
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-if="
                      searchPartitionColumns && searchPartitionColumns.length > 0
                    "
                  >
                    <ul v-if="!partitionLoading">
                      <li
                        :class="[selectedPartitionNameBg === base64(item.name) ? 'base-role-select-list-action' : '']"
                        v-for="(item, index) in searchPartitionColumns"
                        :key="index"
                        @mouseover="partitionOnMouseOver(item)"
                        @click="partitionOnConfirm(item)"
                      >
                        {{ item.name | base64decode }}
                      </li>
                    </ul>
                    <p v-else class="base-role-waiting-box-pc">
                      <img
                        class="base-role-waiting-box-icon-pc"
                        src="https://act.xinyue.qq.com/activity/tgclub/14723/069bf28dc6a8c5645ea400aa19a1e03b.jpg"
                        alt=""
                      />加载中
                    </p>
                  </div>
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-else
                  >
                    <P class="base-role-pop-p-right-select-list-no-pc"
                      >暂未找到更多的区服</P
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- 角色 -->
            <div
              class="base-role-add-area-pop-list-pc base-role-add-area-pop-list-no-border-pc"
            >
              <p class="base-role-pop-p-left-pc">角色</p>
              <div class="base-role-pop-p-right-pc" ref="showRolePop">
                <div
                  class="base-role-pop-p-right-select-pc"
                  @click="showRolePopup"
                >
                  <span
                    class="base-role-color-light-pc"
                    v-if="selectedRoleName === -1"
                    >请选择</span
                  >
                  <span class="base-role-color-light-on-pc" v-else>{{
                    selectedRoleName
                  }}</span>
                  <img
                    class="base-role-arrowhead-box-pc"
                    src="https://act.xinyue.qq.com/activity/tgclub/14723/6d9b52cbd3e55fcc4ab40fcf5d219d3b.jpg"
                    alt=""
                  />
                </div>
                <div
                  class="base-role-pop-p-right-select-list-pc base-role-pop-p-right-select-list-role-pc"
                  v-show="showRolePop"
                >
                  <div class="base-role-arrowhead-box-search-pc">
                    <img
                      class="base-role-arrowhead-box-pc"
                      src="https://act.xinyue.qq.com/activity/tgclub/14564/9f54b976c057f2b5cfa7fb1f9c28316a.jpg"
                      alt=""
                    />
                    <div class="base-role-select-showPartition-parent-pc">
                      {{ roleKeyWord }}
                      <input
                        class="base-role-select-showPartition-pc"
                        @input="handleSearchRoleList(roleKeyWord)"
                        v-model="roleKeyWord"
                        placeholder="搜索"
                      />
                    </div>
                  </div>
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-if="searcRoleColumns && searcRoleColumns.length > 0"
                  >
                    <ul>
                      <li
                        :class="[selectedRoleNameBg === base64(item.role_name) ? 'base-role-select-list-action' : '']"
                        v-for="(item, index) in searcRoleColumns"
                        :key="index"
                        @mouseover="roleOnMouseOver(item)"
                        @click="roleOnConfirm(item)"
                      >
                        {{ item.role_name | base64decode }}
                      </li>
                    </ul>
                  </div>
                  <div
                    class="base-role-pop-p-right-select-list-content-pc"
                    v-else
                  >
                    <P class="base-role-pop-p-right-select-list-no-pc"
                      >暂时没有查找到相关角色</P
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!-- h5端 -->
    <van-popup
      v-else
      v-model="showAddRolePop"
      round
      position="center"
      :style="showAddRolePopStyle"
      :close-on-click-overlay="false"
    >
      <div class="base-role-pop-content" :style="hasChannelPopStyle">
        <div class="base-role-pop-title">添加游戏角色</div>
        <div class="base-role-pop-body">
          <div class="s_content">
            <div class="base-role-add-area-pop-list" v-show="!isClientGame">
              <p class="base-role-pop-p-left">平台</p>
              <p class="base-role-pop-p-right" @click="showAreaPopup">
                <span class="base-role-color-light" v-if="selectedArea === -1"
                  >请选择</span
                >
                <span class="base-role-color-dark" v-else>{{
                  selectedArea
                }}</span>
                <img
                  class="base-role-arrowhead-box"
                  src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                  v-show="selectedArea === -1"
                  alt=""
                />
              </p>
              <span class="add-area-pop-line"></span>
            </div>
            <div
              class="base-role-add-area-pop-list"
              v-show="area_channel_select === 1"
            >
              <p class="base-role-pop-p-left">大区</p>
              <p class="base-role-pop-p-right" @click="showAreaChannelPopup">
                <span
                  class="base-role-color-light"
                  v-if="selectedAreaChannel === -1"
                  >请选择</span
                >
                <span class="base-role-color-dark" v-else>{{
                  selectedAreaChannel
                }}</span>
                <img
                  class="base-role-arrowhead-box"
                  src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                  v-show="selectedAreaChannel === -1"
                  alt=""
                />
              </p>
              <span class="add-area-pop-line"></span>
            </div>
            <div class="base-role-add-area-pop-list" :style="noAreaStyle">
              <p class="base-role-pop-p-left">
                {{ area_channel_select === 1 ? "小区" : "区服" }}
              </p>
              <p class="base-role-pop-p-right" @click="showPartitionPopup">
                <span
                  class="base-role-color-light"
                  v-if="selectedPartitionName === -1"
                  >请选择</span
                >
                <span class="base-role-color-dark" v-else>{{
                  selectedPartitionName
                }}</span>
                <img
                  class="base-role-arrowhead-box"
                  src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                  v-show="selectedPartitionName === -1"
                  alt=""
                />
              </p>
              <span class="add-area-pop-line"></span>
            </div>
            <div class="base-role-add-area-pop-list">
              <p class="base-role-pop-p-left">角色</p>
              <p class="base-role-pop-p-right" @click="showRolePopup">
                <span
                  class="base-role-color-light"
                  v-if="selectedRoleName === -1"
                  >请选择</span
                >
                <span class="base-role-color-dark" v-else>{{
                  selectedRoleName
                }}</span>
                <img
                  class="base-role-arrowhead-box"
                  src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/arrowhead.png"
                  v-show="selectedRoleName === -1"
                  alt=""
                />
              </p>
            </div>
          </div>
        </div>
        <div class="base-role-act">
          <span class="base-role-top-line"></span>
          <div class="base-role-act-cancel" @click="closeAddRolePop">取消</div>
          <div class="base-role-act-confirm" @click="confirmAddRole">确定</div>
          <span class="base-role-center-line"></span>
        </div>
      </div>
    </van-popup>
    <!-- 添加游戏角色end -->
    <div v-if="!isPlatformPc" class="base-role-show-area-pop">
      <!-- 选择平台弹窗开始 -->
      <van-popup
        v-model="showAreaPop"
        round
        position="bottom"
        :style="borderRadiusStyle"
      >
        <van-picker
          title="选择平台"
          show-toolbar
          :columns="areaColumn"
          value-key="text"
          visible-item-count="3"
          confirm-button-text="确定"
          @confirm="areaOnConfirm"
          @cancel="areaOnCancel"
          @change="areaOnChange"
          :default-index="defaultIndex"
        />
      </van-popup>
      <!-- 选择平台弹窗结束 -->
      <!-- 选择大区弹窗开始 -->
      <van-popup
        v-model="showAreaChannelPop"
        round
        position="bottom"
        :style="borderRadiusStyle"
      >
        <van-picker
          title="选择大区"
          show-toolbar
          :columns="areaChannelColumn"
          value-key="name"
          visible-item-count="3"
          confirm-button-text="确定"
          @confirm="areaChannelOnConfirm"
          @cancel="areaChannelOnCancel"
          @change="areaChannelOnChange"
        >
          <template #option="option">
            <div
              style="display: flex; flex-direction: column; align-items: center"
            >
              <div>{{ option.name | base64decode }}</div>
            </div>
          </template>
        </van-picker>
      </van-popup>
      <!-- 选择大区弹窗结束 -->
      <!-- 选择区服弹窗开始 -->
      <div class="base-role-select-showPartition">
        <van-popup
          v-model="showPartitionPop"
          round
          position="bottom"
          :style="borderRadiusStyle"
          @closed="clearAllInput"
        >
          <van-field
            placeholder="搜索"
            v-model="keyWord"
            left-icon="https://game.gtimg.cn/images/tgclub/act/vipmb_new/search.png"
            @input="handleSearchPartitions(keyWord)"
            v-show="areaNeedSearch"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="clearAllInput"
              ></van-button>
            </template>
          </van-field>
          <van-picker
            :class="{
              'base-role-needSearch': areaNeedSearch,
              'base-role-notNeedSearch': !areaNeedSearch,
            }"
            :title="area_channel_select === 1 ? '选择小区' : '选择区服'"
            show-toolbar
            :columns="searchPartitionColumns"
            value-key="name"
            :default-index="0"
            visible-item-count="7"
            confirm-button-text="确定"
            @confirm="partitionOnConfirm"
            @cancel="partitionOnCancel"
            @change="partitionOnChange"
            :loading="partitionLoading"
          >
            <template #option="option">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <div>{{ option.name | base64decode }}</div>
              </div>
            </template>
          </van-picker>
          <div
            class="base-role-areaNoData"
            :style="{ height: scrollerHeight, width: '100%' }"
            v-show="keyWord !== '' && searchPartitionColumns.length === 0"
          ></div>
        </van-popup>
      </div>
      <!-- 选择区服弹窗结束 -->
      <!-- 选择角色弹窗开始 -->
      <van-popup
        v-model="showRolePop"
        round
        position="bottom"
        :style="borderRadiusStyle"
      >
        <van-picker
          title="选择角色"
          show-toolbar
          :columns="roleList"
          value-key="role_name"
          visible-item-count="3"
          confirm-button-text="确定"
          @confirm="roleOnConfirm"
          @cancel="roleOnCancel"
          @change="roleOnChange"
        >
          <template #option="option">
            <div
              style="display: flex; flex-direction: column; align-items: center"
            >
              <div>{{ option.role_name | base64decode }}</div>
            </div>
          </template>
        </van-picker>
      </van-popup>
      <!-- 选择角色弹窗结束 -->
    </div>
  </div>
</template>


<script>
import { Partition, Role, User, Game } from '../apis';
import common from '../../common';
import CDialog from '../base-dialog';
import Vue from 'vue';
import request from '../apis/request';
import 'vant/lib/index.css';

export default {
  name: 'game-role-select',
  components: {
    [CDialog.name]: CDialog,
    VanPopup: () => import('vant/lib/popup'),
    VanPicker: () => import('vant/lib/picker'),
    VanField: () => import('vant/lib/field'),
    VanButton: () => import('vant/lib/button'),
  },
  filters: {
    base64decode(value) {
      return common.tool.Base64.decode(value);
    },
  },
  props: {
    game_code: String,
    options: {
      type: Object,
      default: () => ({
        defaultPartitionId: '',
        defaultRoleId: '',
        defaultPartitionName: '',
      }),
    },
    option: {
      type: Object,
      default: () => ({
        dialogStyle: {},
        confirmStyle: {},
        cancelStyle: {},
        closeStyle: {},
      }),
    },
  },
  data() {
    return {
      device: '',
      check: false,
      isShow: false,
      isMobile:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      showUnbind: false,

      authorizedGameName: '',
      isShowRoleList: false,
      showConfirmPop: false,
      showAreaPop: false,
      showPartitionPop: false,
      showRolePop: false,
      showAddRolePop: false,
      selectedBindRoleInfo: {},

      selectedDevice: '',
      selectedAreaBg: -1,
      selectedArea: -1,
      selectedRoleId: -1,
      selectedRoleNameBg: -1,
      selectedRoleName: -1,
      selectedPartitionId: -1,
      selectedPartitionNameBg: -1,
      selectedPartitionName: -1,
      selectedRoleInfo: {},
      partitionColumns: [],
      roleList: [],
      getAllBindRoleTag: false,

      checkIndex: -1,
      keyWord: '',
      partitionKeyWord: '',
      roleKeyWord: '',
      searchPartitionColumns: [],
      searcRoleColumns: [],
      tempHeight: 0,
      firstLock: false,
      areaNeedSearch: true,

      showAreaChannelPop: false,
      selectedAreaChannelBg: -1,
      selectedAreaChannel: -1,
      selectedAreaChannelId: -1,
      areaChannelColumn: [],
      area_channel_select: 0, // 是否有大区
      partitionLoading: true,
      defaultIndex: 0,
    };
  },
  computed: {
    base64() {
      return value => common.tool.Base64.decode(value);
    },
    roleListPop() {
      return Object.assign(
        {},
        {
          confirm: '确定',
          cancel: '取消',
          fotter: true,
          header: '请选择游戏角色',
          dialogStyle: {},
          confirmStyle: {},
          cancelStyle: {},
          closeStyle: {},
          width: '500px',
          height: 'auto',
          close: false,
        },
      );
    },
    confirmPop() {
      return Object.assign(
        {},
        {
          confirm: '确定',
          cancel: '取消',
          fotter: true,
          header: '请确认授权',
          confirmStyle: {},
          cancelStyle: {},
          closeStyle: {},
          dialogStyle: {},
          width: '500px',
          height: 'auto',
          close: false,
        },
      );
    },
    popOption() {
      return Object.assign(
        {},
        {
          confirm: '确定',
          cancel: '取消',
          fotter: true,
          header: '添加游戏角色',
          dialogStyle: {},
          confirmStyle: {},
          cancelStyle: {},
          closeStyle: {},
          width: '500px',
          height: 'auto',
          close: false,
        },
      );
    },
    isPlatformPc() {
      let platform = '';
      if (common?.platform?.platform) {
        platform = common?.platform?.platform;
      }
      return platform === 'pc';
    },
    showComfirmPopStyle() {
      return {
        width: '6rem',
        height: '3.82rem',
        background: '#FFF',
        overflowY: 'hidden',
        borderRadius: '0.24rem',
      };
    },
    showAddRolePopStyle() {
      return {
        width: '6rem',
        // height: '6.24rem',
        background: '#FFF',
        overflowY: 'hidden',
        borderRadius: '0.24rem',
      };
    },
    hasChannelPopStyle() {
      let height = '6.24rem';
      if (!this.isClientGame && this.area_channel_select === 1) {
        height = '7.24rem';
      }
      return {
        height,
      };
    },
    noAreaStyle() {
      let marginTop = '0.32rem';
      if (this.isClientGame && this.area_channel_select !== 1) {
        marginTop = '0.9rem';
      }
      return {
        marginTop,
      };
    },
    borderRadiusStyle() {
      return {
        borderRadius: '0.24rem 0.24rem 0 0',
      };
    },
    // 端游判断
    isClientGame() {
      return this.$actInfo && this.$actInfo.game_type === 1;
    },
    isRoleReady() {
      return Vue.prototype?.$storeInstance?.state?.isRoleReady;
    },
    roleInfo() {
      return Vue.prototype?.$storeInstance?.state?.roleInfo;
    },
    allBindRoleList() {
      return Vue.prototype?.$storeInstance?.state?.bindRoleList;
    },
    partitionName() {
      if (Vue.prototype?.$storeInstance?.state?.isRoleReady) {
        return common.tool.Base64.decode(Vue.prototype?.$storeInstance?.state?.roleInfo.partition_name || '');
      }
      return '';
    },
    roleName() {
      if (Vue.prototype?.$storeInstance?.state?.isRoleReady) {
        return common.tool.Base64.decode(Vue.prototype?.$storeInstance?.state?.roleInfo.role_name || '');
      }
      return '';
    },
    areaColumn() {
      if (common.tool.getCookie('acctype') === 'wx') {
        switch (this.device) {
          // case 'ios':
          //   return [{ text: 'iOS 微信', device: 'ios', area: 'wx' }];
          // case 'android':
          //   return [{ text: '安卓 微信', device: 'android', area: 'wx' }];
          default:
            return [
              { text: 'iOS 微信', device: 'ios', area: 'wx' },
              { text: '安卓 微信', device: 'android', area: 'wx' },
            ];
        }
      }
      switch (this.device) {
        // case 'ios':
        //   return [{ text: 'iOS 手Q', device: 'ios', area: 'qq' }];
        // case 'android':
        //   return [{ text: '安卓 手Q', device: 'android', area: 'qq' }];
        default:
          return [
            { text: 'iOS 手Q', device: 'ios', area: 'qq' },
            { text: '安卓 手Q', device: 'android', area: 'qq' },
          ];
      }
    },
    scrollerHeight() {
      return this.tempHeight;
    },
    getAccountType() {
      if (common.tool.getCookie('acctype') === 'wx') {
        return 'wx';
      }
      return 'qq';
    },
    titleName() {
      if (this.area_channel_select === 1) {
        return '小区';
      }
      return '区服';
    },
    nowUseGid() {
      return Vue.prototype?.$storeInstance?.getters?.currentGid;
    },
  },
  async mounted() {
    this.isShow = true;
    const response = await User.getActivityAuthorize({
      business: this.$actInfo.ast,
      activity: `${this.$actInfo.activity_id}`,
    });
    if (response.ret !== 0) {
      this.alert('获取授权信息失败');
      return;
    }

    if (response.data.status === 1) {
      this.check = true;
    } else {
      this.check = false;
    }

    this.device = common.platform.device;
    await this.getAllBindRole();
    await this.getAreaChannelList();
    // console.log('【game-role-select】this.allBindRoleList==', Vue.prototype?.$storeInstance?.state?.bindRoleList);

    if (this.check) {
      if (Vue.prototype?.$storeInstance?.state?.bindRoleList.length > 0) {
        this.showRoleList();
      } else {
        this.showAddRolePopup();
      }
    } else {
      this.showConfirmPop = true;
      this.reportExposeFunc('show_pop', { pop_name: 'authorized' });
      this.reportFunc('login_click', { type: 'role' });
    }
  },
  methods: {
    cancelAuthorize() {
      this.showConfirmPop = false;
      this.reportFunc('click_pop', { pop_name: 'authorized', type: 'cancel' });
    },
    async confirmAuthorize() {
      const response = await User.activityAuthorize({
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        status: 1,
      });
      if (response.ret === 0) {
        this.check = true;
      }
      this.showConfirmPop = false;
      this.showAddRolePopup();
      this.reportFunc('click_pop', { pop_name: 'authorized', type: 'confirm' });
    },
    showAddRolePopup() {
      this.isShowRoleList = false;
      this.showAddRolePop = true;

      this.selectedDevice = common.platform.isIos ? 'ios' : 'android';
      if (this.selectedDevice === 'ios') {
        this.defaultIndex = 0;
      } else {
        this.defaultIndex = 1;
      }
      this.selectedArea = this.areaColumn[this.defaultIndex].text;
      this.selectedAreaBg = this.areaColumn[this.defaultIndex].text;
      if (this.area_channel_select === 1) {
        this.getAreaChannelList();
      } else {
        this.fetchPartition();
      }
      this.reportExposeFunc('show_pop', { pop_name: 'add_role' });
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'other' });
      this.reportExposeFunc('login_expose', { type: 'add_role' });
    },
    closeAddRolePop() {
      this.selectInfoInit();
      this.showAddRolePop = false;
      // this.$emit("close");
    },
    selectInfoInit() {
      this.selectedArea = -1;
      this.selectedAreaChannel = -1;
      this.selectedAreaChannelId = -1;
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.partitionColumns = [];
    },
    /**
     * 确认添加角色到角色选择列表
     * @returns {Promise<void>}
     */
    async confirmAddRole() {
      if (Object.keys(this.selectedRoleInfo).length === 0) {
        this.$toast('请选择角色');
        return;
      }
      // console.log('this.selectedRoleInfo====', this.selectedRoleInfo);
      const roleInfo = this.selectedRoleInfo;
      const reportRoleInfo = JSON.parse(JSON.stringify(this.selectedRoleInfo));
      reportRoleInfo.partition_name = common.tool.Base64.decode(reportRoleInfo.partition_name);
      reportRoleInfo.role_name = common.tool.Base64.decode(reportRoleInfo.role_name);
      // console.log('report_roleInfo ====', report_roleInfo);
      const scene = this.$actInfo.ast;
      await this.bindRoleByScene1({
        roleInfo,
        scene,
      });
      await this.getAllBindRoleListByScene(scene);
      this.getAllBindRoleTag = true;
      this.selectInfoInit();
      this.showAddRolePop = false;
      this.isShowRoleList = true;
      // this.reportFunc('click_pop', { pop_name: 'add_role', type: 'confirm', status: '1' });
      this.reportFunc('click_pop', { pop_name: 'add_role', type: 'confirm', status: '1', report_scene: scene, report_role_info: reportRoleInfo });
    },
    /**
     * 添加绑定的角色到指定场景（scene）
     * @param roleInfo
     * @param scene
     * @returns {Promise<void>}
     */
    async bindRoleByScene1({ roleInfo, scene }) {
      await Game.bindRole(
        {
          game_code: this.game_code,
          device: this.selectedDevice, // common.platform.device,
          role: roleInfo,
        },
        scene,
      );
    },
    /**
     * 查询指定场景（scene）绑定的角色列表
     * @param scene
     * @returns {Promise<void>}
     */
    async getAllBindRoleListByScene(scene) {
      const bindRoleList = await Game.getRecentRoleList(
        {
          game_code: this.game_code,
          device: 'both', // common.platform.device,
          num: 5,
        },
        scene,
      );
      // console.log('【game-role-select】[STORE] bindRoleList=', bindRoleList);
      Vue.prototype?.$storeInstance?.commit(
        'UPDATE_BIND_ROLE_LIST',
        bindRoleList,
      );
    },
    showRoleList() {
      this.isShowRoleList = true;
      this.reportExposeFunc('show_pop', { pop_name: 'select_role' });
      this.reportFunc('login_click', { type: 'role' });
    },
    closeRoleList() {
      this.isShowRoleList = false;
      // this.$emit("close");
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'cancel' });
    },
    showAreaPopup() {
      this.isShowRoleList = false;
      this.showAreaPop = true;
      this.reportFunc('click_pop', { pop_name: 'add_role', type: 'plat' });
      if (this.isPlatformPc) {
        const that = this;
        document.addEventListener('click', (e) => {
          if (!that.$refs?.showAreaPop?.contains(e.target)) {
            this.selectedAreaBg = this.selectedArea;
            that.showAreaPop = false;
          }
        });
      }
    },
    areaOnMouseOver(value) {
      this.selectedAreaBg = value.text;
    },
    areaOnConfirm(value) {
      // console.log('【game-role-select】areaOnConfirm当前值：', value);
      this.selectedAreaBg = value.text;
      this.selectedArea = value.text;
      this.selectedDevice = value.device;
      if (this.area_channel_select === 1) {
        this.getAreaChannelList();
      } else {
        this.fetchPartition();
      }
      this.selectedRoleInfo = {};
      this.selectedAreaChannel = -1;
      this.selectedAreaChannelId = -1;
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.showAreaPop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    // eslint-disable-next-line
    areaOnChange(picker, value) {
      // console.log('【game-role-select】areaOnChange当前值：', value);
    },
    areaOnCancel() {
      this.selectInfoInit();
      this.showAreaPop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    showAreaChannelPopup() {
      if (
        !this.isClientGame
        && this.area_channel_select === 1
        && this.selectedArea === -1
      ) {
        this.$toast('请选择平台');
        return false;
      }
      this.isShowRoleList = false;
      this.showAreaChannelPop = true;
      this.reportFunc('click_pop', { pop_name: 'add_role', type: 'channel' });
      if (this.isPlatformPc) {
        const that = this;
        document.addEventListener('click', (e) => {
          if (!that.$refs?.showAreaChannelPop?.contains(e.target)) {
            this.selectedAreaChannelBg = this.selectedAreaChannel;
            that.showAreaChannelPop = false;
          }
        });
      }
    },
    areaChannelOnMouseOver(value) {
      this.selectedAreaChannelBg = common.tool.Base64.decode(value.name);
    },
    async areaChannelOnConfirm(value) {
      // console.log('【game-role-select】areaChannelOnConfirm当前值：', value);
      this.selectedAreaChannelBg = common.tool.Base64.decode(value.name);
      this.selectedAreaChannel = common.tool.Base64.decode(value.name);
      this.selectedAreaChannelId = value.id.toString();
      await this.fetchPartition();
      if (this.partitionColumns.length === 0) {
        this.$toast('没有查询到你的角色');
      }
      this.selectedRoleInfo = {};
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.showAreaChannelPop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    // eslint-disable-next-line
    areaChannelOnChange(picker, value) {
      // console.log('【game-role-select】areaChannelOnChange当前值：', value);
    },
    areaChannelOnCancel() {
      this.selectedAreaChannel = -1;
      this.selectedAreaChannelId = -1;
      this.showAreaChannelPop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    showPartitionPopup() {
      if (!this.isClientGame && this.selectedArea === -1) {
        this.$toast('请选择平台');
        return false;
      }
      if (this.area_channel_select === 1 && this.selectedAreaChannel === -1) {
        this.$toast('请选择大区');
        return false;
      }
      if (
        this.area_channel_select === 1
        && this.searchPartitionColumns.length === 0
      ) {
        this.$toast('你选的大区暂无区服');
        return false;
      }

      this.isShowRoleList = false;
      this.partitionKeyWord = '';
      this.showPartitionPop = true;
      /* if (this.partitionColumns.length === 1) {
        this.selectedRoleName = this.partitionColumns[0].name;
        this.selectedRoleId = -this.partitionColumns[0].id;
        this.refreshRoleList();
      }*/
      if (!this.isPlatformPc) {
        this.$nextTick(() => {
          const els = 'base-role-select-showPartition';
          const el = document.querySelector(`.${els}` + ' .van-picker__columns');
          if (el !== undefined && this.firstLock === false) {
            this.tempHeight = `${el.offsetHeight}px`;
            this.firstLock = true;
          }
        });
      } else {
        const that = this;
        document.addEventListener('click', (e) => {
          if (!that.$refs?.showPartitionPop?.contains(e.target)) {
            this.selectedPartitionNameBg = this.selectedPartitionName;
            that.showPartitionPop = false;
          }
        });
      }
    },
    partitionOnMouseOver(value) {
      this.selectedPartitionNameBg = common.tool.Base64.decode(value.name);
    },
    async partitionOnConfirm(value) {
      this.selectedPartitionNameBg = common.tool.Base64.decode(value.name);
      this.selectedPartitionName = common.tool.Base64.decode(value.name);
      this.selectedPartitionId = value.id;
      try {
        await this.refreshRoleList(value.name);
        // console.log('【game-role-select】partitionOnConfirm===', this.roleList);
        if (this.roleList.length === 0) {
          this.$toast(`你选的${this.titleName}暂无角色`);
          this.selectedRoleInfo = {};
          this.selectedRoleName = -1;
          this.selectedRoleId = -1;
          this.roleList = [];
          return false;
        }
        if (this.roleList.length === 1) {
          this.selectedRoleNameBg = common.tool.Base64.decode(this.roleList[0].role_name);
          this.selectedRoleName = common.tool.Base64.decode(this.roleList[0].role_name);
          this.selectedRoleId = this.roleList[0].role_id;
          [this.selectedRoleInfo] = this.roleList;
        }
        this.showPartitionPop = false;
      } catch (err) {
        console.error('【game-role-select】refreshRoleList fail, err=', err);
        if (err?.data?.ret === 300011) {
          this.$toast(`你在该${this.titleName}没有角色`);
        } else {
          const txt = err?.data?.msg || '角色查询失败';
          this.$toast(txt);
        }
      }
    },
    // eslint-disable-next-line
    partitionOnChange(picker, value) {
      // console.log('【game-role-select】partitionOnChange当前值：', value);
    },
    partitionOnCancel() {
      this.selectedPartitionName = -1;
      this.selectedPartitionId = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.showPartitionPop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    showRolePopup() {
      if (!this.isClientGame && this.selectedArea === -1) {
        this.$toast('请选择平台');
        return false;
      }
      if (this.area_channel_select === 1 && this.selectedAreaChannel === -1) {
        this.$toast('请选择大区');
        return false;
      }
      if (this.selectedPartitionId === -1) {
        this.$toast(`请选择${this.titleName}`);
        return false;
      }
      if (this.roleList.length === 0) {
        this.$toast(`你选的${this.titleName}暂无角色`);
        return false;
      }
      this.isShowRoleList = false;
      this.showRolePop = true;
      this.roleKeyWord = '';
      if (this.isPlatformPc) {
        const that = this;
        document.addEventListener('click', (e) => {
          if (!that.$refs?.showRolePop?.contains(e.target)) {
            this.selectedRoleNameBg = this.selectedRoleName;
            that.showRolePop = false;
          }
        });
      }
    },
    roleOnMouseOver(value) {
      this.selectedRoleNameBg = common.tool.Base64.decode(value.role_name);
    },
    // eslint-disable-next-line
    roleOnConfirm(value, index) {
      if (typeof value === undefined || typeof value === 'undefined') {
        this.$toast(`你选的${this.titleName}暂无角色`);
        return;
      }
      // console.log(`【game-role-select】当前role_name：${value.role_name}, 当前role_id：${value.role_id}, 当前索引：${index}`);
      this.selectedRoleNameBg = common.tool.Base64.decode(value.role_name);
      this.selectedRoleName = common.tool.Base64.decode(value.role_name);
      this.selectedRoleId = value.role_id;
      this.selectedRoleInfo = value;
      this.showRolePop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    // eslint-disable-next-line
    roleOnChange(picker, value, index) {
      // console.log(`【game-role-select】当前role_name：${value.role_name}, 当前role_id：${value.role_id}, 当前索引：${index}`);
    },
    roleOnCancel() {
      this.showRolePop = false;
      if (this.isPlatformPc) {
        document.removeEventListener('click', () => ({}));
      }
    },
    /**
     * 获取区服列表
     * @returns partitionColumns 当前area下的区服列表
     */
    async fetchPartition() {
      this.selectedPartitionId = -1;
      this.selectedPartitionName = -1;
      this.selectedRoleName = -1;
      this.selectedRoleId = -1;
      this.roleList = [];
      this.partitionLoading = true;
      this.partitionColumns = await Partition.fetch({
        game_code: this.game_code,
        device: this.selectedDevice,
        area: this.getAccountType,
        // gid: this.$actInfo.gid,
        gid: this.nowUseGid,
        scene: this.$actInfo.ast,
        is_auth: false,
        area_channel_id:
          this.area_channel_select === 1 ? this.selectedAreaChannelId : '',
      });
      this.searchPartitionColumns = this.partitionColumns;
      this.partitionLoading = false;
      // console.log('【game-role-select】searchPartitionColumns==', this.searchPartitionColumns.length);
      // 如果只有默认大区，自动拉取角色
      /* if (this.searchPartitionColumns.length === 1) {
        await this.partitionOnConfirm(this.searchPartitionColumns[0]);
      }*/
    },
    /**
     * 获取角色列表
     * @returns roleList 当前查询区服下的角色列表
     */
    async refreshRoleList() {
      this.roleList = [];
      // const partitionInfo = this.partitionColumns.find(item => item.name === partitionName);
      // const { id: partitionId  = '' }  =   partitionInfo || {};
      this.selectedRoleId = '';
      this.roleList = await Role.fetch({
        game_code: this.game_code,
        // gid: this.$actInfo.gid,
        gid: this.nowUseGid,
        device: this.selectedDevice,
        // partition_id: +partitionId,
        partition_id: this.selectedPartitionId,
        scene: this.$actInfo.ast,
        area_channel_id:
          this.area_channel_select === 1 ? this.selectedAreaChannelId : '',
      });
      this.searcRoleColumns = this.roleList;
    },
    async getAllBindRole() {
      const scene = this.$actInfo.ast;
      await this.getAllBindRoleListByScene(scene);
      this.getAllBindRoleTag = true;
    },
    changeSelect(role, index) {
      // console.log('【changeSelect】changeSelect-role ===', role);
      this.checkIndex = index;
      this.selectedBindRoleInfo = role;
    },
    /**
     * 修改当前活动绑定角色数据
     */
    async changeActBind() {
      const sceneTemp = `${this.$actInfo.ast}_act_${this.$actInfo.activity_id}`;  // tgclub_act_11025
      // console.log('【changeActBind】===', sceneTemp);
      if (this.isRoleReady === true && this.checkIndex === -1) {
        this.isShowRoleList = false;
        // this.$emit("close");
        if (Object.keys(this.selectedBindRoleInfo).length > 0) {
          const reportRoleInfo1 = JSON.parse(JSON.stringify(this.selectedBindRoleInfo));
          reportRoleInfo1.partition_name = common.tool.Base64.decode(reportRoleInfo1.partition_name);
          reportRoleInfo1.role_name = common.tool.Base64.decode(reportRoleInfo1.role_name);
          this.reportFunc('click_pop', { pop_name: 'select_role', type: 'confirm', report_scene: sceneTemp, report_role_info: reportRoleInfo1 });
        } else {
          const reportRoleInfo2 = JSON.parse(JSON.stringify(this.roleInfo));
          reportRoleInfo2.partition_name = common.tool.Base64.decode(reportRoleInfo2.partition_name);
          reportRoleInfo2.role_name = common.tool.Base64.decode(reportRoleInfo2.role_name);
          this.reportFunc('click_pop', { pop_name: 'select_role', type: 'confirm', report_scene: sceneTemp, report_role_info: reportRoleInfo2 });
        }
        this.$emit('close');
        return;
      }
      if (Object.keys(this.selectedBindRoleInfo).length === 0) {
        this.$toast('您尚未勾选角色');
        return;
      }
      const reportRoleInfo = JSON.parse(JSON.stringify(this.selectedBindRoleInfo));
      reportRoleInfo.partition_name = common.tool.Base64.decode(reportRoleInfo.partition_name);
      reportRoleInfo.role_name = common.tool.Base64.decode(reportRoleInfo.role_name);
      this.reportFunc('click_pop', { pop_name: 'select_role', type: 'confirm', report_scene: sceneTemp, report_role_info: reportRoleInfo });
      this.$emit('finish', this.selectedBindRoleInfo);
    },
    /**
     * 处理区服搜索功能
     * @param partitionKeyWord 搜索内容
     */
    handleSearchPartitions(keyWord) {
      const els = 'base-role-select-showPartition';
      const el = document.querySelector(`.${els}` + ' .van-picker__columns');
      if (keyWord === '') {
        this.searchPartitionColumns = this.partitionColumns;
        if (el !== undefined && !this.isPlatformPc) {
          el.style.display = 'flex';
        }
        return;
      }
      const t = [];
      this.partitionColumns.forEach((item) => {
        const temp = common.tool.Base64.decode(item.name || '');
        if (temp.indexOf(keyWord) > -1) {
          t.push(item);
        }
      });
      this.searchPartitionColumns = t;
      if (this.searchPartitionColumns.length === 0) {
        if (el !== undefined && !this.isPlatformPc) {
          el.style.display = 'none';
        }
      } else {
        if (el !== undefined && !this.isPlatformPc) {
          el.style.display = 'flex';
        }
      }
    },
    /**
     * 处理角色搜索功能
     * @param keyWord 搜索内容
     */
    handleSearchRoleList(keyWord) {
      if (keyWord === '') {
        this.searcRoleColumns = this.roleList;
        return;
      }
      const t = [];
      this.searcRoleColumns.forEach((item) => {
        const temp = common.tool.Base64.decode(item.role_name || '');
        if (temp.indexOf(keyWord) > -1) {
          t.push(item);
        }
      });
      this.searcRoleColumns = t;
    },
    /**
     * 清除搜索框输入内容
     */
    clearAllInput() {
      this.keyWord = '';
      this.handleSearchPartitions(this.keyWord);
    },

    reportFunc(key, obj) {
      if (
        typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0]
        === 'function'
      ) {
        const params = {
          ceibaComponentId: '',
          ceibaComponentUid: '',
          ceibaComponentUname: '区服角色组件',
          eventKey: key,
          eventData: obj,
        };
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
    reportExposeFunc(key, obj) {
      if (
        typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0]
        === 'function'
      ) {
        const params = {
          ceibaComponentId: '',
          ceibaComponentUid: '',
          ceibaComponentUname: '区服角色组件',
          eventType: 1001,
          eventKey: key,
          eventData: obj,
        };
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
    /**
     * 获取大区列表
     */
    async getAreaChannelList() {
      const device =        this.selectedDevice !== '' ? this.selectedDevice : this.device;
      const response = await request.post('amp2.RoleSrv/GetAreaChannelList', {
        game_code: this.game_code,
        // gid: this.$actInfo.gid,
        gid: this.nowUseGid,
        device: this.isClientGame ? '' : device,
        area: this.getAccountType,
      });
      // console.log('【game-role-select】getAreaChannelList==', response);
      if (response.ret === 0 && response.list.length > 0) {
        this.area_channel_select = 1;
        this.areaChannelColumn = response.list;
      }
    },
  },
};
</script>

<style>
@import './index.css';
</style>
